import React from "react";
import {Calendar, Cast, Filter, Loader,} from "react-feather";
import img_licitacoes from "../../imagens/mob_licitacoes.png";
import {CollCard, CollImg, ContainerBody, Wrapper} from "../styleMobile";
import {CardFeatures} from "../Components/CardFeatures";
import {CardHearder} from "../Components/CardHearde";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const Licitacoes = ({id}) => {
    return (
        <ContainerBody id={id} background={'#9F645C'}>
            <Wrapper>
                <CardHearder
                    icon={<span style={{fontSize: '40px'}}><FontAwesomeIcon icon={"gavel"} color="#00000"/></span>}
                    titulo={'LICITAÇÕES'}
                    texto={'Tenha acesso a todas as informações do procedimento licitatório, centralizadas, organizadas e atualizadas em apenas um lugar.'}
                />

                <CollImg>
                    <div>
                        <img
                            src={img_licitacoes}
                            height={"auto"}
                            width={"100%"}
                            alt={"logo wavecode"}
                        />
                    </div>
                </CollImg>

                <CollCard>
                    <CardFeatures icon={<Cast/>} texto={"LICITAÇÕES DO DIA"}/>
                    <CardFeatures icon={<Loader/>} texto={"SINCRONIZAÇÃO AUTOMÁTICA"}/>
                    <CardFeatures icon={<Calendar/>} texto={"MODO AGENDA"}/>
                    <CardFeatures icon={<Filter/>} texto={"MODO FUNIL"}/>
                </CollCard>

            </Wrapper>
        </ContainerBody>
    )
};
